import React from "react";
import { LockIcon } from "lucide-react";
import { CTAButton } from "./CTAButton";
type SectionCTAProps = {
  label: string;
  dark?: boolean;
};
export function SectionCTA({
  label,
  dark = false
}: SectionCTAProps) {
  return <div className="mx-auto mt-10 w-full max-w-xl" data-id="element-70" data-mp="1lc1rk3cie65e">
      <CTAButton label={label} data-id="element-71" data-mp="1qbxxw98oi9o4" />
      <p className={`mt-3 flex items-center justify-center gap-1.5 text-center text-sm ${dark ? "text-white/75" : "text-ink-muted"}`} data-id="element-72" data-mp="1qav5txzme16m">
        <LockIcon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-73" data-mp="1bkxbt1f0eh9i" />
        One-time payment of <strong className={dark ? "text-white" : "text-ink"} data-id="element-74" data-mp="1gfb9xbl232hv">$27 USD</strong> · 7-Day Guarantee
      </p>
    </div>;
}